module.exports = __webpack_public_path__ + "static/img/hot.f366c27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/game/hot.png
// module id = ETFf
// module chunks = 2